export default __webpack_public_path__ + "static/media/spinner-white.c872608c.svg";